import { FC, useEffect } from 'react'
import RegistrationForm from '@/components/organisms/registration/registrationForm'
import { Flex } from '@/components/atoms/Grid'
import { Routes } from '@/core/routes'
import PageContentWrapper from '@/components/organisms/pageContentWrapper'
import { Page } from '@/network/graphql.g'
import { isLoggedInBySession } from '@/providers/userProvider'
import { withNotProtectedRoute } from '@/HOC/withNotProtectedRoute'
import { withBaseServerSideProps } from '@/HOC/withBaseServerSideProps'
import { requestThrow401 } from '@/utils/graphQl'
import { useMhub } from '@/providers/mhubProvider'
import { getMainData } from '@/utils/mainDataHelper'
import { useSpeedCurve } from '@/core/speedCurve/useSpeedCurve'

const Register: FC = () => {
  const { pushRegisterPage } = useMhub()
  useEffect(() => {
    pushRegisterPage()
  }, [])

  useSpeedCurve({
    label: 'Register'
  })

  return (
    <PageContentWrapper>
      <Flex
        justifyContent="center"
        width="100%"
        pt={{ mobile: 30, tablet: 40, desktop: 60 }}
        pb={100}
        data-testid="registrationForm"
      >
        <RegistrationForm />
      </Flex>
    </PageContentWrapper>
  )
}

export const getServerSideProps = withBaseServerSideProps(
  async ({
    session,
    sdk,
    withMainNavigation,
    withStore
  }): Promise<GetServerSideProps<Rest>> => {
    if (isLoggedInBySession(session)) {
      return {
        redirect: {
          destination: Routes.home,
          permanent: false
        }
      }
    }

    const { response } = await requestThrow401({
      method: sdk.getSeoTags,
      variables: {
        page: Page.Register,
        withMainNavigation,
        withStore
      }
    })

    return {
      props: {
        mainData: getMainData(response),
        seoTags: response?.seoTags
      }
    }
  }
)

export default withNotProtectedRoute(Register)
